export default "__VITE_ASSET__36d3612c__"